import React from 'react';
import { LoadMainIcon, TruckIcon } from '@hero/web-icons';
import type { MockOrder, MockViewerRole } from '../types';
import { EditAffordance } from './EditAffordance';

export interface LoadCardProps {
  order: MockOrder;
  viewer: MockViewerRole;
}

/**
 * Vehicle, weight, temperature, packing. Click on the card opens
 * the load drawer in production; here we just log. The shipper
 * (and broker re-publishing) can edit; carrier and driver are
 * read-only.
 */
export const LoadCard: React.FC<LoadCardProps> = ({ order, viewer }) => {
  const canEdit = viewer === 'shipper' || viewer === 'broker';
  const { vehicleType, weightKg, tempC, packing } = order.load;

  const rows: Array<{ label: string; value: string }> = [];
  rows.push({ label: 'Vehicle', value: vehicleType });
  if (weightKg !== undefined) {
    rows.push({ label: 'Weight', value: `${weightKg.toLocaleString()} kg` });
  }
  if (tempC !== undefined) {
    rows.push({ label: 'Temp', value: `${tempC}°C` });
  }
  if (packing) {
    rows.push({ label: 'Packing', value: packing });
  }

  return (
    <button
      type="button"
      onClick={() => console.log('[orders-preview] open load drawer')}
      className="w-full text-start rounded-xl border border-gray-200 bg-white p-4 shadow-sm hover:border-gray-300 transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="rounded-lg bg-orange-50 p-1.5">
            <LoadMainIcon className="size-4 text-orange-600" />
          </div>
          <h4 className="text-[14px] font-semibold text-gray-900">Load</h4>
        </div>
        <EditAffordance canEdit={canEdit} field="load" />
      </div>

      <div className="mt-3 flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-600">
          <TruckIcon className="size-4" />
        </div>
        <dl className="grid flex-1 grid-cols-2 gap-x-3 gap-y-1.5">
          {rows.map(row => (
            <React.Fragment key={row.label}>
              <dt className="text-[12px] text-gray-500">{row.label}</dt>
              <dd className="text-[12px] font-medium text-end text-gray-900 truncate">
                {row.value}
              </dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </button>
  );
};
